import { BaseMessageInfo } from "./BaseMessageInfo";
import { CnstContractBus } from "./CnstContractBus";
import { CnstJobBus } from "./CnstJobBus";
import { DQOIItem } from "./DQOIItem";

export class CnstMessageInfo extends BaseMessageInfo
{
    contract: CnstContractBus;
    job: CnstJobBus;
    dqoiItem: DQOIItem;
    statusChangeOk: boolean;
    closeOutResourceWarning: boolean;
}
